import { useSearchParams } from 'react-router-dom';

export type PeriodPreset = 7 | 30 | 90 | 365 | 0;

export const PERIOD_PRESETS: { value: PeriodPreset; label: string }[] = [
  { value: 7, label: '7d' },
  { value: 30, label: '30d' },
  { value: 90, label: '90d' },
  { value: 365, label: '1 ano' },
  { value: 0, label: 'Tudo' },
];

const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

export function useAdminPeriod() {
  const [searchParams, setSearchParams] = useSearchParams();
  const from = searchParams.get('from') || '';
  const to = searchParams.get('to') || '';
  const isCustom = DATE_RE.test(from) && DATE_RE.test(to) && to >= from;

  const presetParam = parseInt(searchParams.get('period') || '30', 10);
  const preset: PeriodPreset = (PERIOD_PRESETS.find((p) => p.value === presetParam)?.value ?? 30) as PeriodPreset;

  const apiQuery = isCustom ? `from=${from}&to=${to}` : `period=${preset}`;

  const setPreset = (p: PeriodPreset) => setSearchParams({ period: String(p) });
  const setCustom = (f: string, t: string) => setSearchParams({ from: f, to: t });

  return { isCustom, preset, from, to, apiQuery, setPreset, setCustom };
}
